<template>
  <div>
    <div class="head-btns">
      <add-dialog @change="getList" :classId="$route.query.id">
        <div class="mwow-button-filled success">添加学员</div>
      </add-dialog>
      <div class="mwow-button-filled primary" @click="handleChangeClassMulti">
        更换班级
      </div>
      <div class="mwow-button-filled warning" @click="handleMultiDelete">
        离开班级
      </div>
    </div>
    <el-table
      size="mini"
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column label="学员姓名" prop="name">
        <template slot-scope="scope">
          {{ scope.row.name || "-"
          }}<span
            v-if="scope.row.is_del === 1"
            class="mwow-tag del-filled large"
            >已删除</span
          >
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile">
        <template slot-scope="scope">
          {{ "+" + scope.row.area_code }} {{ scope.row.mobile }}
        </template>
      </el-table-column>
      <el-table-column label="排课课程" prop="course_list" width="240">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.consume_course_id"
            @change="(v) => handleCourseChange(v, scope)"
          >
            <el-option
              v-for="item in scope.row.course_list"
              :key="item.course_id"
              :label="item.title"
              :value="item.course_id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="剩余课时" prop="left">
        <template slot-scope="scope">
          {{
            scope.row.current_course &&
            scope.row.current_course.account.usable_number
          }}<span
            v-if="
              scope.row.current_course &&
              scope.row.current_course.account.stop_status === 2
            "
            class="mwow-yellow"
            >（停课中）</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button
            class="mwow-button primary"
            @click="handleChangeClass(scope.row)"
            >更换班级</el-button
          >
          <el-button
            class="mwow-button warinning"
            @click="handleDelete(scope.row.student_id)"
            >离开班级</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 更换班级 -->
    <el-dialog
      title="更换班级"
      destroy-on-close
      :visible.sync="changeDialogVisible"
    >
      <change-dialog
        v-if="changeDialogVisible"
        :visible.sync="changeDialogVisible"
        :sids="changeDialogSids"
        :courseId="changeDialogCourseId"
        @change="getList"
        :classId="$route.query.id"
      ></change-dialog>
    </el-dialog>
  </div>
</template>
<script>
import addDialog from "./addDialog.vue";
import changeDialog from "./changeDialog.vue";
import {
  deleteStudent,
  getStudentList,
  studentCourseSet,
} from "@/api/classManagement";

export default {
  name: "classDetailStudent",
  components: {
    addDialog,
    changeDialog,
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      changeDialogVisible: false,
      changeDialogSids: [],
      changeDialogCourseId: 0,
    };
  },

  created() {
    this.getList();
  },
  methods: {
    getList() {
      const cid = Number(this.$route.query.id);
      if (cid) {
        getStudentList({ class_id: cid }).then((res) => {
          if (res.error_code === 0) {
            res.data.list.map((item) => {
              item.current_course = item.course_list.filter((it) => {
                return it.course_id === item.consume_course_id;
              })[0];
            });
            this.tableData = res.data.list;
          }
        });
      }
    },
    handleChangeClass(row) {
      this.changeDialogSids = [row.student_id];
      this.changeDialogCourseId = row.consume_course_id;
      this.changeDialogVisible = true;
    },
    handleChangeClassMulti() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "error",
          message: "请先选择学员",
        });
        return false;
      }
      const arr = [];
      const course = new Set();
      this.multipleSelection.map((item) => {
        arr.push(item.student_id);
        course.add(item.consume_course_id);
      });
      this.changeDialogSids = arr;
      if (course.size > 1) {
        this.$message({
          type: "error",
          message: "批量换班时所选学员当前课程需一致",
        });
        return false;
      }
      const course_id = Array.from(course)[0];
      this.changeDialogCourseId = course_id;
      this.changeDialogVisible = true;
    },
    closeChangeDialog() {
      this.changeDialogVisible = false;
    },
    handleCourseChange(cid, scope) {
      const arr = [...this.tableData];
      this.$confirm(
        "更换后，后续排课的消耗课程，都以切换后的课程为主。",
        `更换消耗课程 - ${arr[scope.$index].current_course.title}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          studentCourseSet({
            class_id: Number(this.$route.query.id),
            course_id: cid,
            student_id: arr[scope.$index].student_id,
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "更换成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "更换失败!" + res.message,
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete(sid) {
      this.$confirm("确定离开？", `离开班级`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          const cid = Number(this.$route.query.id);
          deleteStudent({
            class_id: cid,
            student_ids: [sid],
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "请求成功!",
              });
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "请求失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleMultiDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "error",
          message: "请先选择学员",
        });
        return false;
      }
      this.$confirm("确定离开？", `离开班级`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          const cid = Number(this.$route.query.id);
          const arr = [];
          this.multipleSelection.map((item) => {
            arr.push(item.student_id);
          });
          deleteStudent({
            class_id: cid,
            student_ids: arr,
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "请求成功!",
              });
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "请求失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.head-btns {
  margin-bottom: 14px;
  .mwow-button-filled {
    margin-right: 20px;
  }
}
</style>
